# Positioning variants:
#--------------------------------------------------------------------------------------
#         |      TA      |          | TL: "top-left"             | LT: "left-top"     |
#   TLC    --------------    TRC    | TR: "top-right"            | LB: "left-bottom"  |
#         | TL | TC | TR |          | TC: "top-center"           | LC: "left-center"  |
# --- ---- -------------- ---- ---  | TA: "top-auto"             | LA: "left-auto"    |
#    | LT |              | RT |     | TRC: "top-right-corner"    | RT: "right-top"    |
# LA | LC |    target    | RC | RA  | TLC: "top-left-corner"     | RB: "right-bottom" |
#    | LB |              | RB |     | BL: "bottom-left"          | RC: "right-center" |
# --- ---- -------------- ---- ---  | BR: "bottom-right"         | RA: "right-auto"   |
#         | BL | BC | BR |          | BC: "bottom-center"        |                    |
#   BLC    --------------    BRC    | BA: "bottom-auto"          |                    |
#         |      BA      |          | BRC: "bottom-right-corner" |                    |
#                                   | BLC: "bottom-left-corner"  |                    |
#--------------------------------------------------------------------------------------
# "auto" - rjpopover will automatically take the position when it fits into the page (in case it is visible).
# For "top-auto" and "bottom-auto" rjpopover will try to fit with positions in the order LEFT, CENTER, RIGHT (LEFT if it doesn't fit in all cases).
# For "left-auto" and "right-auto" rjpopover will try to fit with positions in the order TOP, CENTER, BOTTOM (TOP if it doesn't fit in all cases).
#
# Attribute:                         Default:                   Example:                     Description:
#--------------------------------------------------------------------------------------------------------
# rjpopover-container                body (class)               ".container-{{metric.id}}"    Div into th DOM where rjpopover will be located.
# rjpopover-templateurl              * (angular template)       "template.rjpopover.html"     Have to have class="rjpopover" in the first div.
# rjpopover-target                   target element (class)     ".target-{{metric.id}}"       The element near which will be located rjpopover.
# rjpopover-placement                left-center (string)       "bottom-left-corner"          See table above.
# rjpopover-topshift                 0                          "-10"                         Add an additional shift to the position top value (in px).
# rjpopover-leftshift                0                          "15"                          Add an additional shift to the position left value (in px).
# rjpopover-group                    none (string)              "report-builder-page"         If there is a group then only one rjpopover from the group can be visible.
# rjpopover-hideifclickedoutside     false (boolean)            true or false                 Hide rjpopover if clicking outside it. (except additional buttons)
# rjpopover-index                    none (string)              "{{metric.id}}"               Additional index for showing/closing rjpopover by broadcasting or emitting "rjpopover-hide-by-index" event.
# rjpopover-actiononshow             none (function)            "setIndex({{$index}})"        Function which will be executed after rjpopover was shown.
# rjpopover-actiononhide             none (function)            "removeIndex()"               Function which will be executed after rjpopover was hidden.
# rjpopover-additionalbutton         none (class)               ".buttons-{{metric.id}}"      **
# rjpopover-autopositioning          false (boolean)            true or false                 ***
#
# *  '<div class="rjpopover" ng-show="popView.visible"><div>'
# **  When buttons are related then rjpopover hidden/shown only by the same button (double click on the button).
#     When clicking one time by all related buttons one by one rjpopover stays opened and "popView.lastClickedButton"
#     changes indexes of clicked buttons (0 - main button, [1..n] - additional buttons).
#     This indexes can be used for example for switching tabs on rjpopover.
# *** On every $digest cycle checks the position of targetElement and if it was changed then updates popover's position.
#     If position contains "auto" then, in addition, checks browser window width and height.
angular.module('rjmNg.directives').directive "rjpopover", [
  "$timeout"
  "$templateCache"
  "$compile"
  "$document"
  "rjpopover"
  ($timeout, $templateCache, $compile, $document, rjpopover) ->
    restrict: "A"
    scope: true
    controllerAs: "popView"
    controller: () ->
      popView = @

      popView.visible = false
      popView.lastClickedButton = 0

      popView
    link: (scope, elem, attrs, popView) ->

      # Read attrs
      container = attrs.rjpopoverContainer or "body"
      templateUrl = attrs.rjpopoverTemplateurl
      target = attrs.rjpopoverTarget or null
      placement = attrs.rjpopoverPlacement or "left-center"
      group = attrs.rjpopoverGroup or null
      additionalButton = attrs.rjpopoverAdditionalbutton or null
      hideIfClickedOutside = (attrs.rjpopoverHideifclickedoutside is "true") or false
      autoPositioning = (attrs.rjpopoverAutopositioning is "true") or false
      index = attrs.rjpopoverIndex or null
      actionOnShow = attrs.rjpopoverActiononshow or false
      actionOnHide = attrs.rjpopoverActiononhide or false
      topShift = parseInt(attrs.rjpopoverTopshift) or 0
      leftShift = parseInt(attrs.rjpopoverLeftshift) or 0

      # All additional buttons for rjpopover will store here
      additionalButtonsList = []
      # Target element defines when rjpopover is positioned the first time
      targetElement = []


      # Create rjpopover
      defaultTemplate = '<div class="rjpopover" ng-show="popView.visible"><div>'
      template = $templateCache.get(templateUrl) or defaultTemplate

      rjpopoverElement = angular.element(template)
      popView.id = rjpopover.getglobalId()
      popView.index = index

      _toggleVisible = () ->
        popView.visible = not popView.visible

      popView.hide = (groupHide=false) ->
        # Check if rjpopover was visible, in case closing by group
        if popView.visible
          _toggleVisible()
          if actionOnHide and not groupHide
            # Eval function from attrs in case it was changed
            scope.$eval(attrs.rjpopoverActiononhide)

      popView.show = () ->
        if not popView.visible
          _toggleVisible()
          if actionOnShow
            # Eval function from attrs in case it was changed
            scope.$eval(attrs.rjpopoverActiononshow)
          # Close other rjpopovers from group
          if group
            rjpopover.hideGroup(group, popView.id)

      popView.locate = (element=targetElement) ->
        topLeft = getRjpopoverPosition(element)
        rjpopoverElement.css({'top' : topLeft[0] + topShift + 'px'})
        rjpopoverElement.css({'left' : topLeft[1] + leftShift + 'px'})

      $compile(rjpopoverElement)(scope)

      autoPositioningListener = null
      _targetPositionAndSizeListener = () ->
        if popView.visible
          result = getTargetPositionAndSize(targetElement)
          if "auto" in placement.split("-")
            result.clientHeight = document.documentElement.clientHeight
            result.clientWidth = document.documentElement.clientWidth
        else
          result = null
        return result

      # Add rjpopover into the DOM (wait until DOM created)
      $timeout () ->
        angular.element(document.querySelector(container)).append(rjpopoverElement)
        # If we have target element, then use it, else use target element of rjpopover
        targetElement = if target then angular.element(document.querySelector(target)) else elem
        popView.locate(targetElement)

        if autoPositioning
          # create/overwrite listener
          autoPositioningListener = scope.$watch(
            _targetPositionAndSizeListener
            (newValue, oldValue) ->
              if newValue isnt oldValue
                popView.locate(targetElement)
            true
          )

      # Click events on target element (button), inside rjpopover, and outside rjpopover
      _clickOnButton = (event) ->
        # Need to do an $spply here to force a digest, since this is triggered by a jqlite event
        scope.$apply(
          if popView.visible
            if popView.lastClickedButton is event.data.buttonId
              popView.hide()
          else
            popView.show()
          popView.lastClickedButton = event.data.buttonId
        )

      _clickOutsideRjpopover = (event) ->
        if popView.visible
          clickedOnadditionalButton = false
          if additionalButton and additionalButtonsList.length > 0
            for button in additionalButtonsList
              if button.contains(event.target)
                clickedOnadditionalButton = true
                break
          # if rjpopover visible and clicked outside rjpopover and target element (button)
          if not (elem[0] is event.target or \
                  elem[0].contains(event.target) or \
                  rjpopoverElement[0].contains(event.target) or \
                  clickedOnadditionalButton)
            # Need to do an $spply here to force a digest, since this is triggered by a jqlite event
            scope.$apply(
              popView.hide()
            )

      elem.on('click', {buttonId: 0}, _clickOnButton)

      if hideIfClickedOutside
        $document.on('click', _clickOutsideRjpopover)

      if additionalButton
        $timeout () ->
          additionalButtonsList = angular.element(document.querySelectorAll(additionalButton))
          buttonCount = 1
          for button in additionalButtonsList
            angular.element(button).on('click', {buttonId: buttonCount}, _clickOnButton)
            buttonCount += 1


      # Add rjpopover to the group
      rjpopover.addToGroup(popView, group)


      # Directives should clean up after themselves
      _cleanUp = () ->
        # remove listeners
        elem.off('click', {buttonId: 0}, _clickOnButton)
        if hideIfClickedOutside
          $document.off('click', _clickOutsideRjpopover)
        if autoPositioning
          autoPositioningListener()
        # remove rjpopover DOM element
        rjpopoverElement.remove()
        # remove rjpopover from group
        rjpopover.removeFromGroupById(group, popView.id)
        return

      scope.$on('$destroy', _cleanUp)


      # Functions
      getTargetPositionAndSize = (element) ->
        domRect = element[0].getBoundingClientRect()
        position = element.position()
        positionAndSize =
          top: position.top # relative to the offset target
          left: position.left # relative to the offset target
          topDom: domRect.top # relative to the document
          leftDom: domRect.left # relative to the document
          width: element.outerWidth()
          height: element.outerHeight()
        return positionAndSize

      getRjpopoverPosition = (element) ->
        targetSize = getTargetPositionAndSize(element)
        bodySize = document.body.getBoundingClientRect()
        # Get rjpopover size
        rjpopoverSize =
          width: rjpopoverElement.outerWidth()
          height: rjpopoverElement.outerHeight()
        temp = placement.split("-")
        position = temp[0]
        alignment = temp[1]
        corner = if temp[2] then temp[2] else null
        return rjpopover.getRjpopoverTopLeft(targetSize, bodySize, rjpopoverSize, position, alignment, corner)

]
